import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  modalData:any= {}
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<ConfirmModalComponent>,
              private router: Router) { }

  ngOnInit(): void {
    this.modalData = this.data
  }

  navigate() {
    if(this.modalData?.navigator) {
      this.router.navigate([this.modalData?.navigator])
    }
    this.dialogRef.close(true)
  }

}
